import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";

interface MatchingPackagesModalProps {
  open: boolean;
  onClose: () => void;
  matchingPackages: string[];
}

export const MatchingPackagesModal: React.FC<MatchingPackagesModalProps> = ({ open, onClose, matchingPackages }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ backgroundColor: "#1b1a19", color: "#fff" }}>Matching Packages for Regex</DialogTitle>
      <DialogContent sx={{ backgroundColor: "#1b1a19", color: "#fff" }}>
        {matchingPackages.length === 0 ? (
          <Typography variant="body1" sx={{ color: "#aaa", textAlign: "center" }}>
            No matching packages found.
          </Typography>
        ) : (
          <TableContainer sx={{ backgroundColor: "#1b1a19", borderRadius: 2 }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: "#333" }}>
                  <TableCell sx={{ color: "#fff" }}>Package Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {matchingPackages.map((pkg, index) => (
                  <TableRow key={index}>
                    <TableCell sx={{ color: "#fff" }}>{pkg}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions sx={{ backgroundColor: "#1b1a19" }}>
        <Button onClick={onClose} variant="outlined" sx={{ color: "#fff" }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
